import { v } from "react-router/dist/development/index-react-server-client-DKvU8YRr";
import { formatarCep, formatarNumeroCelular, formatarNumeroTelefone } from "./formatadorservice";

const FormatUtils = {
  ehTelefoneValido: (number: String) => {
    const cleaned = number.toString().replace(/\D/g, "");
    const match = cleaned.match(/^(\d{2})(\d{5})(\d{4})$/);
    if (match) {
      return true;
    }
    return false;
  },
  dataAtualISO: () => new Date().toISOString().split('T')[0],

  dataHoraAtualISO: () => new Date().toISOString(),
  ehCpfCnpjValido: (number: String) => {
    const cleaned = number.toString().replace(/\D/g, "");
    const matchCnpj = cleaned.match(/^(\d{2})(\d{3})(\d{3})(\d{3})(\d{2})$/);
    if (matchCnpj) {
      return true;
    }
    const matchCpf = cleaned.match(/^(\d{3})(\d{3})(\d{3})(\d{2})$/);
    if (matchCpf) {
      return true;
    }
    return false;
  },

  formatDate: (valor: string | number | Date) => {
    return valor ? new Date(valor).toISOString().split('T')[0] : ''
  },

  ehCepValido: (number: String) => {
    const cleaned = number.toString().replace(/\D/g, "");
    const matchCEP = cleaned.match(/^(\d{2})(\d{3})(\d{3})$/);
    if (matchCEP) {
      return true;
    }
    return false;
  },

  formatarNumeroCelular: <String>(number: String) => {
    if (!number) {
      return number;
    }

    const cleaned = number.toString().replace(/\D/g, "");
    const match = cleaned.match(/^(\d{2})(\d{5})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return number;
  },

  formatarNumeroTelefone: (number: String) => {
    const cleaned = number.toString().replace(/\D/g, "");
    const match = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return number;
  },


  getMesByNumero: (mes: number) => {
    const meses = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ];
    return meses[mes - 1];
  },

  formatarData: (date: unknown) => {
    if (!(date instanceof Date)) {
      throw new Error("Parâmetro inválido. Forneça um objeto Date válido.");
    }

    const dia = String(date.getDate()).padStart(2, "0");
    const mes = String(date.getMonth() + 1).padStart(2, "0"); // Janeiro é 0
    const ano = date.getFullYear();

    return `${dia}/${mes}/${ano}`;
  },


  getHoraByDateTime(dateTimeString: Date) {
    const date = new Date(dateTimeString);
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  },

  parseDateWithoutTimezone: (dateString: String) => {
    const [year, month, day] = dateString.split("-").map(Number);
    return new Date(year, month - 1, day);
  },

  parseToBrddMMyyyy: (dateString: String) => {
    const [year, month, day] = dateString.split("-").map(Number);
    return (
      (day < 10 ? "0" : "") +
      day +
      "/" +
      ((month < 10 ? "0" : "") + month) +
      "/" +
      year
    );
  },

  parseDateToString(date: unknown) {
    if (!(date instanceof Date)) {
      throw new Error("Parâmetro inválido: forneça um objeto Date válido.");
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  },
  parseToString: (date: Date) => {
    const dateString = date.toISOString().split("T")[0];
    return dateString;
  },

  parseDateUtc: (dateString: String) => {
    const [year, month, day] = dateString.split("-").map(Number);
    const date = new Date(year, month - 1, day, 0, 0, 0);
    return date;
  },

  formatarDataExtenso: (data: Date) => {
    if (data)
      return new Intl.DateTimeFormat("pt-BR", {
        weekday: "long",
        day: "2-digit",
        month: "long",
      }).format(data);
  },

  formatarHora: (date: unknown) => {
    if (!(date instanceof Date)) {
      throw new Error("Parâmetro inválido. Forneça um objeto Date válido.");
    }

    const hour = date.getHours();
    const minutes =
      date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
    //const seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();

    return `${hour}:${minutes}`;
  },

  formatarInteiro: (number: unknown) => {
    if (number) {
      const cleaned = number
        .toString()
        .replace(/[^0-9,]/g, "")
        .replace(".", "");
      const match = cleaned.split(",");
      if (match) {
        return `${match[0]}`;
      }
    } else {
      return 0;
    }

    return number;
  },
  formatarDecimal: (number: unknown) => {
    if (number) {
      const cleaned = number
        .toString()
        .replace(/[^0-9,]/g, "")
        .replace(".", "");
      const match = cleaned.split(",");
      if (match) {
        return `${match[0]}${match[1] ? "," + match[1] : ""}`;
      }
    } else {
      return 0;
    }
    return number;
  },

  formatarDecimalConcluido: (number: unknown) => {
    if (number) {
      const cleaned = number
        .toString()
        .replace(/[^0-9,]/g, "")
        .replace(".", "");
      const match = cleaned.split(",");
      if (match) {
        return `${match[0]}${match[1] ? "," + match[1] : ",00"}`;
      }
    } else {
      return 0;
    }
    return number;
  },

  formatarCpfCnpj: <String>(number: string) => {
    const cleaned = number.toString().replace(/\D/g, "");
    const matchCnpj = cleaned.match(/^(\d{2})(\d{3})(\d{3})(\d{3})(\d{2})$/);
    if (matchCnpj) {
      return `${matchCnpj[1]}.${matchCnpj[2]}.${matchCnpj[3]}/${matchCnpj[4]}-${matchCnpj[5]}`;
    }
    const matchCpf = cleaned.match(/^(\d{3})(\d{3})(\d{3})(\d{2})$/);
    if (matchCpf) {
      return `${matchCpf[1]}.${matchCpf[2]}.${matchCpf[3]}-${matchCpf[4]}`;
    }
    return number;
  },

  formatarCEP: <String>(number: string) => {
    const cleaned = number.toString().replace(/\D/g, "");
    const matchCEP = cleaned.match(/^(\d{2})(\d{3})(\d{3})$/);
    if (matchCEP) {
      return `${matchCEP[1]}.${matchCEP[2]}-${matchCEP[3]}`;
    }
    return number;
  },

  parseDateTime: (dateStr: String, timeStr: String) => {
    if (!dateStr || !timeStr) {
      throw new Error("Os parâmetros de data e hora são obrigatórios.");
    }

    const [year, month, day] = dateStr.split("-").map(Number);
    const [hours, minutes, seconds] = timeStr.split(":").map(Number);

    // Criando um objeto Date (mês em JS é baseado em zero, então subtraímos 1)
    return new Date(year, month - 1, day, hours, minutes, seconds);
  },

  formatarDataBrasil<String>(data: Date) {
    return data.toLocaleString("pt-BR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false, // Usa formato 24h
    });
  },

  formatarDataHoraLocal(isoString = "") {
    if (!isoString) return "";

    const data = new Date(isoString);

    return data.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  },



  formatDateTime<String>(valor: string | number | Date | null | undefined) {
    try {
      if (!valor) {
        return '';
      }
      const date = valor === "hoje" ? new Date() : new Date(valor);
      const tzOffset = date.getTimezoneOffset() * 60000; // em ms
      const localISOTime = new Date(date.getTime() - tzOffset).toISOString().slice(0, 16);
      return localISOTime;
    } catch (error) {
      return valor;
    }
  },

  getDiaSemanaExtenso: (diaEnum: String) => {
    switch (diaEnum) {
      case 'SEGUNDA': return 'Segunda-feira';
      case 'TERCA': return 'Terça-feira';
      case 'QUARTA': return 'Quarta-feira';
      case 'QUINTA': return 'Quinta-feira';
      case 'SEXTA': return 'Sexta-feira';
      case 'SABADO': return 'Sábado';
      case 'DOMINGO': return 'Domingo';
    }

  },

  getDiaSemanaEnum: (date: Date) => {
    const dia = new Date(date);

    // Obtém o nome do dia em português, tudo em maiúsculo
    let diaSemana = dia
      .toLocaleDateString("pt-BR", { weekday: "long" }).split("-")[0]
      .toUpperCase();

    // Remove acentos e caracteres especiais (ex: Ç, Á, É, Ã)
    diaSemana = diaSemana.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    return diaSemana;
  },
  getDataHoje: () => {
    const hojeLocal = new Date();
    return new Date(hojeLocal.getFullYear(), hojeLocal.getMonth(), hojeLocal.getDate())
  },
  getDataHojeFimDoDia: () => {
    const hojeLocal = new Date();
    return new Date(hojeLocal.getFullYear(), hojeLocal.getMonth(), hojeLocal.getDate(), 23, 59, 59)
  },

  aplicarFormatoGrade: (campo: any, valor: any) => {
    if (campo.opcoes && valor) {
      return FormatUtils.getDescricaoOpcao(campo, valor)
    } else if (campo?.fk?.campo && valor && valor[campo.fk.campo]) {
      return FormatUtils.aplicarFormato(valor[campo.fk.campo], "string")
    } else if (campo.tipo === 'Date' && !campo.formato) {
      return FormatUtils.aplicarFormato(valor, 'data');

    } else if (campo.tipo === 'DateTime' && !campo.formato) {
      return FormatUtils.formatDateTime(valor);
    }
    return FormatUtils.aplicarFormato(valor, campo?.tipo ?? "string");
  },


  aplicarFormato: (valor: any, pattern: string): string => {
    if (valor == null) return '';

    const str = valor === true ? '1' : valor.toString().replace(/\D/g, ''); // remove tudo que não for número


    switch (pattern) {
      case 'Boolean':
        return (str === '1' || str === true) ? 'Sim' : 'Nao';
      case 'celular':
        return formatarNumeroCelular(str);
      case 'telefone':

        return formatarNumeroTelefone(str);

      case 'cep':
        return formatarCep(str);

      case 'cpf':
        // XXX.XXX.XXX-XX
        return str.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');

      case 'cnpj':
        // XX.XXX.XXX/XXXX-XX
        return str.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');

      case 'data':
        const date = new Date(valor);
        return isNaN(date.getTime()) ? '' : date.toLocaleDateString('pt-BR');

      case 'hora':
        // HH:mm
        const match = str.match(/^(\d{2})(\d{2})$/);
        return match ? `${match[1]}:${match[2]}` : valor.toString();

      case 'moeda':
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(valor));

      case 'percentual':
        return Number(valor).toFixed(2).replace('.', ',') + '%';

      case 'numero':
        return str; // retorna apenas números

      case 'Long':
      case 'Integer':
        return str; // retorna apenas números
      case 'BigDecimal':
      case 'Double':
        return Number(valor).toFixed(2).replace('.', ',');
      default:
        return valor.toString();
    }
  },

  getDescricaoOpcao: (campo: Campo, valor: any) => {
  if (!campo?.opcoes || valor === null || valor === undefined) {
    return valor;
  }

  const valorNormalizado = String(valor);

  const opcao = campo.opcoes.find(
    (c: any) => String(c.valor) === valorNormalizado
  );

  if (!opcao) return valor;

  return opcao.descricao ?? opcao.label ?? opcao.valor;
}

};
export function formatarMoeda(valor: number): string {
  if (valor == null || isNaN(valor)) return '0,00';
  return Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(valor);
}


   export function  aplicarMascaraCelular  (valor: string) : string  {
        const numeros = valor.replace(/\D/g, '');
        if (numeros.length <= 11) {
            return numeros
                .replace(/^(\d{2})(\d)/g, '($1) $2')
                .replace(/(\d{5})(\d)/, '$1-$2')
                .substring(0, 15);
        }
        return numeros.substring(0, 11);
    };

export { FormatUtils };
